import React from 'react';
import { Download, Settings2, Database, Save, Share2, Edit2, Trash2, Sparkles, Copy, Maximize2, Minimize2, LocateFixed, Layers, MapPin, Cpu } from 'lucide-react';
interface MapActionsMenuProps {
  isBackground?: boolean;
  onEditWithAI: () => void;
  onToggleBackground?: () => void;
  onDuplicate?: () => void;
  onRemove?: () => void;
  onClose: () => void;
  showResetPosition?: boolean;
  onResetPosition?: () => void;
  // Compact mode extras
  compactMode?: boolean;
  onOpenLayers?: () => void;
  activeLayersCount?: number;
  onOpenPOI?: () => void;
  activePOIsCount?: number;
  onOpenModel?: () => void;
  selectedModel?: string;
  // Medium mode: only show model in menu
  showModelInMenu?: boolean;
}
export function MapActionsMenu({
  isBackground,
  onEditWithAI,
  onToggleBackground,
  onDuplicate,
  onRemove,
  onClose,
  showResetPosition,
  onResetPosition,
  compactMode,
  onOpenLayers,
  activeLayersCount = 0,
  onOpenPOI,
  activePOIsCount = 0,
  onOpenModel,
  selectedModel,
  showModelInMenu
}: MapActionsMenuProps) {
  return <div className="absolute right-0 top-full mt-2 w-48 rounded-xl shadow-2xl shadow-black/50 z-[1100] py-1 border border-white/[0.08]" style={{
    background: 'rgba(15, 23, 42, 0.55)',
    backdropFilter: 'blur(40px) saturate(180%)',
    WebkitBackdropFilter: 'blur(40px) saturate(180%)',
    isolation: 'isolate'
  }} data-id="element-1452">
      <div className="absolute inset-0 rounded-xl pointer-events-none" style={{
      background: 'linear-gradient(135deg, rgba(255,255,255,0.06) 0%, transparent 50%, rgba(255,255,255,0.02) 100%)'
    }} data-id="element-1453" />

      {/* Compact-mode controls at top */}
      {compactMode && <>
          <button className="relative w-full px-3 py-2 text-left text-xs text-slate-300 hover:bg-white/[0.06] flex items-center justify-between gap-2" onClick={() => {
        onOpenLayers?.();
        onClose();
      }} data-id="element-1454">
            <span className="flex items-center gap-2" data-id="element-1455">
              <Layers size={12} className={activeLayersCount > 0 ? 'text-[#EC4899]' : ''} data-id="element-1456" />
              Weather Layers
            </span>
            {activeLayersCount > 0 && <span className="text-[10px] bg-[#EC4899] text-white rounded-full w-4 h-4 flex items-center justify-center font-bold flex-shrink-0" data-id="element-1457">
                {activeLayersCount}
              </span>}
          </button>
          <button className="relative w-full px-3 py-2 text-left text-xs text-slate-300 hover:bg-white/[0.06] flex items-center justify-between gap-2" onClick={() => {
        onOpenPOI?.();
        onClose();
      }} data-id="element-1458">
            <span className="flex items-center gap-2" data-id="element-1459">
              <MapPin size={12} className={activePOIsCount > 0 ? 'text-[#EC4899]' : ''} data-id="element-1460" />
              Points of Interest
            </span>
            {activePOIsCount > 0 && <span className="text-[10px] bg-[#EC4899] text-white rounded-full w-4 h-4 flex items-center justify-center font-bold flex-shrink-0" data-id="element-1461">
                {activePOIsCount}
              </span>}
          </button>
          <button className="relative w-full px-3 py-2 text-left text-xs text-slate-300 hover:bg-white/[0.06] flex items-center justify-between gap-2" onClick={() => {
        onOpenModel?.();
        onClose();
      }} data-id="element-1462">
            <span className="flex items-center gap-2" data-id="element-1463">
              <Cpu size={12} className="text-[#EC4899]" data-id="element-1464" />
              Model
            </span>
            {selectedModel && <span className="text-[10px] text-white/50 font-mono" data-id="element-1465">
                {selectedModel}
              </span>}
          </button>
          <button className="relative w-full px-3 py-2 text-left text-xs text-slate-300 hover:bg-white/[0.06] flex items-center gap-2" onClick={() => {
        onResetPosition?.();
        onClose();
      }} data-id="element-1466">
            <LocateFixed size={12} data-id="element-1467" /> Reset Position
          </button>
          <div className="h-px bg-white/[0.08] my-1" data-id="element-1468" />
        </>}

      {/* Medium-mode: only model row */}
      {!compactMode && showModelInMenu && <>
          <button className="relative w-full px-3 py-2 text-left text-xs text-slate-300 hover:bg-white/[0.06] flex items-center justify-between gap-2" onClick={() => {
        onOpenModel?.();
        onClose();
      }} data-id="element-1469">
            <span className="flex items-center gap-2" data-id="element-1470">
              <Cpu size={12} className="text-[#EC4899]" data-id="element-1471" />
              Model
            </span>
            {selectedModel && <span className="text-[10px] text-white/50 font-mono" data-id="element-1472">
                {selectedModel}
              </span>}
          </button>
          <div className="h-px bg-white/[0.08] my-1" data-id="element-1473" />
        </>}

      <button className="relative w-full px-3 py-2 text-left text-xs text-[#EC4899] hover:bg-[#EC4899]/10 flex items-center gap-2 font-medium" onClick={() => {
      onEditWithAI();
      onClose();
    }} data-id="element-1474">
        <Sparkles size={12} data-id="element-1475" /> Edit with AI
      </button>

      {showResetPosition && !compactMode && <>
          <div className="h-px bg-white/[0.08] my-1" data-id="element-1476" />
          <button className="relative w-full px-3 py-2 text-left text-xs text-slate-300 hover:bg-white/[0.06] flex items-center gap-2" onClick={() => {
        onResetPosition?.();
        onClose();
      }} data-id="element-1477">
            <LocateFixed size={12} data-id="element-1478" /> Reset Position
          </button>
        </>}

      <div className="h-px bg-white/[0.08] my-1" data-id="element-1479" />
      <button className="relative w-full px-3 py-2 text-left text-xs text-slate-300 hover:bg-white/[0.06] flex items-center gap-2" data-id="element-1480">
        <Download size={12} data-id="element-1481" /> Download PNG
      </button>
      <button className="relative w-full px-3 py-2 text-left text-xs text-slate-300 hover:bg-white/[0.06] flex items-center gap-2" data-id="element-1482">
        <Settings2 size={12} data-id="element-1483" /> Display Settings
      </button>
      <button className="relative w-full px-3 py-2 text-left text-xs text-slate-300 hover:bg-white/[0.06] flex items-center gap-2" data-id="element-1484">
        <Database size={12} data-id="element-1485" /> Edit Data Source
      </button>
      <button className="relative w-full px-3 py-2 text-left text-xs text-slate-300 hover:bg-white/[0.06] flex items-center gap-2" data-id="element-1486">
        <Save size={12} data-id="element-1487" /> Save Settings
      </button>
      <div className="h-px bg-white/[0.08] my-1" data-id="element-1488" />
      <button className="relative w-full px-3 py-2 text-left text-xs text-slate-300 hover:bg-white/[0.06] flex items-center gap-2" data-id="element-1489">
        <Share2 size={12} data-id="element-1490" /> Share
      </button>
      <button className="relative w-full px-3 py-2 text-left text-xs text-slate-300 hover:bg-white/[0.06] flex items-center gap-2" data-id="element-1491">
        <Edit2 size={12} data-id="element-1492" /> Edit
      </button>
      <div className="h-px bg-white/[0.08] my-1" data-id="element-1493" />
      <button className="relative w-full px-3 py-2 text-left text-xs text-slate-300 hover:bg-white/[0.06] flex items-center gap-2" onClick={() => {
      onToggleBackground?.();
      onClose();
    }} data-id="element-1494">
        {isBackground ? <Minimize2 size={12} data-id="element-1495" /> : <Maximize2 size={12} data-id="element-1496" />}
        {isBackground ? ' Exit Background' : ' Use as Background'}
      </button>
      <button className="relative w-full px-3 py-2 text-left text-xs text-slate-300 hover:bg-white/[0.06] flex items-center gap-2" onClick={() => {
      onDuplicate?.();
      onClose();
    }} data-id="element-1497">
        <Copy size={12} data-id="element-1498" /> Duplicate
      </button>
      <button className="relative w-full px-3 py-2 text-left text-xs text-red-400 hover:bg-red-500/10 flex items-center gap-2" onClick={() => {
      onRemove?.();
      onClose();
    }} data-id="element-1499">
        <Trash2 size={12} data-id="element-1500" /> Delete
      </button>
    </div>;
}